import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LoginWorkflowInfo } from "../../../utility/interfaces/loginWorkflowInterfaces";

interface PatientState {
  isOptedIn: boolean;
  isChecked: boolean;
  patientProfileId: number;
  patientCaseId: number;
  patientCaseStatusId: number;
  patientUserId: number;
  userName: string;
  preferredLanguage: string;
  loginWorkflowInfo: LoginWorkflowInfo;
  hideNoShow: boolean;
  isSpolightVisible: boolean;
}

const initialState: PatientState = {
  isOptedIn: false,
  isChecked: false,
  patientProfileId: 0,
  patientCaseId: 0,
  patientCaseStatusId: 0,
  patientUserId: 0,
  userName: "",
  preferredLanguage: "",
  loginWorkflowInfo: {
    patientProfileId: 0,
    userId: 0,
    patientCaseId: 0,
    loginDateTime: "",
    lastLoginDateTime: "",
    mrnId: "",
    userName: "",
    patientCaseStatusId: 0,
    patientCaseCategoryId: 0,
    patientCaseCategoryName: "",
    patientCaseStatusDisplayName: "",
    patientCaseStatusName: "",
    livingStatusAtBirthId: null,
    isReOptin: 0,
    isNoShowVisible: false,
    actualDeliveryDate: null,
  },
  hideNoShow: false,
  isSpolightVisible: true,
};

const patientSlice = createSlice({
  name: "patient",
  initialState,
  reducers: {
    setOptInStatus: (state, action: PayloadAction<boolean>) => {
      state.isOptedIn = action.payload;
      state.isChecked = true;
    },
    setOptInChecked(state, action: PayloadAction<boolean>) {
      state.isChecked = action.payload;
    },
    setPatientProfileId(state, action: PayloadAction<number>) {
      state.patientProfileId = action.payload;
    },
    setPatientCaseId(state, action: PayloadAction<number>) {
      state.patientCaseId = action.payload;
    },
    setPatientCaseStatusId(state, action: PayloadAction<number>) {
      state.patientCaseStatusId = action.payload;
    },
    setPatientUserId(state, action: PayloadAction<number>) {
      state.patientUserId = action.payload;
    },
    setUserName(state, action: PayloadAction<string>) {
      state.userName = action.payload;
    },
    setPreferredLanguage(state, action: PayloadAction<string>) {
      state.preferredLanguage = action.payload;
    },
    setLoginWorkflowData(state, action: PayloadAction<LoginWorkflowInfo>) {
      state.loginWorkflowInfo = action.payload;
    },
    setHideNoShow(state, action: PayloadAction<boolean>) {
      state.hideNoShow = action.payload;
    },
    setIsSpotlightVisible(state, action: PayloadAction<boolean>) {
      state.isSpolightVisible = action.payload;
    },
  },
});

export const {
  setOptInStatus,
  setOptInChecked,
  setPatientProfileId,
  setPatientCaseId,
  setPatientCaseStatusId,
  setPatientUserId,
  setUserName,
  setPreferredLanguage,
  setLoginWorkflowData,
  setHideNoShow,
  setIsSpotlightVisible,
} = patientSlice.actions;
export default patientSlice.reducer;
